const shouldShowMrp = (sp = '0', mrp = '0') => {
  return !(parseInt(sp) === parseInt(mrp));
};

export default shouldShowMrp;
